export default __webpack_public_path__ + "static/media/comics.7dec2f44.png";